export const FAQ_CATEGORIES: any[] = [
    {'value': 'annuncio'},
    {'value': 'candidatura'},
    {'value': 'mappa'},
    {'value': 'accedi'},
    {'value': 'forum'},
];
